import { POST } from "../../APiHelper/API";

export const repopulateTeamsWithPlayers = (team_id, onSuccess, onError) => {
    const data = {}
    POST(`/api/v1/leagues/team/${team_id}/repopulate_players`, data, onSuccess, onError)
}